import { render, staticRenderFns } from "./ShowMenus.vue?vue&type=template&id=3a83c11f&scoped=true"
import script from "./ShowMenus.vue?vue&type=script&lang=ts"
export * from "./ShowMenus.vue?vue&type=script&lang=ts"
import style0 from "./ShowMenus.vue?vue&type=style&index=0&id=3a83c11f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a83c11f",
  null
  
)

export default component.exports